// liste des médias
export enum CORERESOURCES {
  fr = 'assets/core/locales/fr/resources.txt',
  en = 'assets/core/locales/en/resources.txt',
}
